import Vue from 'vue';
import api from '@/api';
import store from '@/store';
import i18n from '@/configured/vue-i18n';
import log from '@/configured/logger';
import { localeToCraftSiteHandle } from '@/configured/languages/config';

const exports = {
  namespace: 'singles',
  module: {
    namespaced: true,
    state: {
      loading: {},
      pages: {},
    },
    mutations: {
      SET_LOADING: (state, {key, request}) => {
        Vue.set(state.loading, key, request);
      },
      SET_PAGE: (state, {key, page}) => {
        const lang = store.state[i18n.store.namespace].language;
        Vue.set(state.pages, key, { lang, page });
        Vue.set(state.loading, key, false);
      },
      CLEAR_PAGE: (state, key) => {
        Vue.delete(state.pages, key);
      },
    },
    actions: {
      isLoading,
      getPage,
      loadPage,
      loadPages,
      clearPage,
    },
  }
};

store.registerModule(exports.namespace.split('/'), exports.module);

export default exports;

//////////
function isLoading({state, commit}, key) {
  log.info('isLoading', state);
  return !!state.loading[key];
}

function getPage({state, commit}, key) {
  return new Promise((resolve, reject) => {
    const lang = store.state[i18n.store.namespace].language;
    if (state.pages.hasOwnProperty(key) && state.pages[key].lang === lang) {
      reloadPage({state, commit}, key);
      resolve(state.pages[key].page);
    } else {
      loadPage({state, commit}, key)
        .then(resolve)
        .catch(reject);
    }
  });
}

function loadPages({state, commit}, keys) {
  const promises = keys.map(key => loadPage({state, commit}, key));
  return Promise.all(promises);
}

function cancelLoad({state, commit}, key) {
  if (state.loading[key]) {
    state.loading[key].cancel('Cancel page load');
    commit('SET_LOADING', {key, request: false});
  }
}

function reloadPage({state, commit}, key) {
  log.info("Reloading page", key);
  return loadPage({state, commit}, key);
}

function loadPage({state, commit}, key) {
  const locale = store.state[i18n.store.namespace].language;
  const site = localeToCraftSiteHandle(locale);
  const url = `/api/${site}/singles/${encodeURIComponent(key)}`;
  const request = api.CancelToken.source();

  if (state.loading[key]) {
    cancelLoad({state, commit}, key);
  }

  commit('SET_LOADING', {key, request});
  return api.get(url, {cancelToken: request.token})
  .then(rsp => {
    const page = rsp.data;
    log.info("Got page", url, page);
    commit('SET_PAGE', {key, page});
    return page;
  })
  .catch(err => {
    if (api.isCancel(err)) {
      log.info("Load request canceled", err);
      commit('SET_LOADING', {key, request: false});
    } else {
      log.error("Error loading page", key, err);
      commit('SET_PAGE', {key, page:{}});
    }
  });
}

function clearPage({state, commit}, key) {
  commit('CLEAR_PAGE', key);
}
